import { useTranslation } from "react-i18next";
import { DocumentIcon } from "@/shared/icons";
import type { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  widgetNoteType: string;
};

export const NoNotesWidget: FC<Props> = ({ widgetNoteType }) => {
  const { t } = useTranslation();

  const noteType = t(`notesPage.noNoteType.${widgetNoteType.toLowerCase()}s`);

  return (
    <div className={styles.empty}>
      <DocumentIcon />
      <p>
        {t("notesPage.noNotes", {
          noteType: noteType,
        })}
      </p>
    </div>
  );
};
